import React, { useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import moment from "moment";

const Checkbox = ({
  name,
  label,
  checked,
  error,
  className,
  divClassName,
  comments,
  addComment,
  editComment,
  deleteComment,
  acknowledgeComment,
  commentsHandler,
  divStyle,
  ...rest
}) => {
  const [showComment, setShowComment] = useState(false);
  let fieldComments =
    commentsHandler !== undefined
      ? commentsHandler({ action: "GET", fieldName: name })
      : comments !== undefined
      ? comments.filter((comment) => comment.field._text === name)
      : [];

  const toggleComment = () => {
    setShowComment(!showComment);
  };

  return (
    <>
      {fieldComments.length > 0 && (
        <>
          {showComment &&
            fieldComments.map((comment, index) => (
              <div
                key={`${comment.field._text}${index}`}
                className={`${
                  comment.acknowledgedby ? "bg-safy3-50" : "bg-warning"
                } m-2 rounded d-print-none`}
                title={
                  comment.acknowledgedby
                    ? `Acknowledged by: ${comment.acknowledgedby._text} ${comment.acknowledgedon._text}`
                    : ""
                }
              >
                <div className="p-2">
                  {comment.createdby._text ===
                    JSON.parse(localStorage.getItem("safyInfo")).user
                      .displayName && (
                    <>
                      <i
                        title="Delete Comment"
                        className="far fa-trash-alt text-white me-2"
                        onClick={() => {
                          confirmAlert({
                            title: "Delete Comment",
                            message:
                              "Are you sure you want to delete this comment?",
                            buttons: [
                              {
                                label: "Yes",
                                onClick: () => {
                                  commentsHandler !== undefined
                                    ? commentsHandler({
                                        action: "DELETE",
                                        comment: comment,
                                      })
                                    : deleteComment(comment);
                                },
                              },
                              {
                                label: "No",
                                onClick: () => {
                                  /* do nothing */
                                },
                              },
                            ],
                          });
                        }}
                      ></i>
                      {!comment.acknowledgedby && (
                        <i
                          title="Edit Comment"
                          className="fas fa-pen text-white me-2"
                          onClick={() => {
                            commentsHandler !== undefined
                              ? commentsHandler({
                                  action: "EDIT",
                                  comment: comment,
                                })
                              : editComment(comment);
                          }}
                        ></i>
                      )}
                    </>
                  )}
                  {commentsHandler !== undefined ||
                  acknowledgeComment !== undefined ? (
                    <>
                      {comment.acknowledgedby && (
                        <i
                          className="far fa-check-square text-white me-2"
                          onClick={() => {
                            if (
                              comment.acknowledgedby._text ===
                              JSON.parse(localStorage.getItem("safyInfo")).user
                                .displayName
                            )
                              commentsHandler !== undefined
                                ? commentsHandler({
                                    action: "ACKNOWLEDGE",
                                    comment: comment,
                                    acknowledge: false,
                                  })
                                : acknowledgeComment(comment, false);
                          }}
                        ></i>
                      )}
                      {!comment.acknowledgedby && (
                        <i
                          className="far fa-square text-white me-2"
                          onClick={() => {
                            commentsHandler !== undefined
                              ? commentsHandler({
                                  action: "ACKNOWLEDGE",
                                  comment: comment,
                                  acknowledge: true,
                                })
                              : acknowledgeComment(comment, true);
                          }}
                          title="Acknowledge Comment"
                        ></i>
                      )}
                    </>
                  ) : null}
                  <br />
                  <span className="h6">
                    {`${comment.createdby._text} - ${moment(
                      comment.datetime._text,
                      "MMMM DD YYYY hh:mm a"
                    ).format("L")} ${moment(
                      comment.datetime._text,
                      "MMMM DD YYYY hh:mm a"
                    ).format("LT")}`}
                  </span>
                  <br />
                  {comment.comment._text}
                </div>
              </div>
            ))}
          <i
            className="fas fa-comment-alt text-warning float-end mb-2 ms-2"
            onClick={toggleComment}
          ></i>
        </>
      )}
      <div
        className={`clearfix row mb-3${divClassName ? ` ${divClassName}` : ""}`}
        style={divStyle}
      >
        <div className="form-check">
          <input
            {...rest}
            name={name}
            id={name}
            checked={checked}
            type="checkbox"
            className={`form-check-input cbox col-2 `}
          />
          <label className="form-check-label col-10" htmlFor={name}>
            <span
              className={`d-none d-print-inline ${
                checked ? "checked" : "not-checked"
              }`}
            />
            {label}
          </label>
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
      </div>
    </>
  );
};

export default Checkbox;
